import React from 'react';

import { RelayEnvironmentProvider } from '@atlassian/relay-environment-provider';

import { EditionAwareness, type EditionAwarenessProps } from './edition-awareness';

export function EditionAwarenessWithRelayEnvironmentProvider(
	props: EditionAwarenessProps,
): React.JSX.Element {
	return (
		<RelayEnvironmentProvider>
			{/* EditionAwareness contains Suspense */}
			<EditionAwareness {...props} />
		</RelayEnvironmentProvider>
	);
}
